import { DOMAttributes } from 'react';

import DOMPurify from 'dompurify';
import { marked } from 'marked';

// Le texte injecté dans dangerouslySetInnerHTML est purifié avec DOMPurify,
// il n'y a donc pas de risque d'injections
export function markdownToSafeInnerHTML(
  markdown?: string | null,
  linkToNewTab?: boolean,
): Pick<DOMAttributes<unknown>, 'dangerouslySetInnerHTML'> {
  // Add hook to set target and rel attribuet
  if (linkToNewTab) {
    DOMPurify.addHook('afterSanitizeAttributes', node => {
      if (node.tagName === 'A') {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
      }
    });
  }

  const html = DOMPurify.sanitize(marked.parse(markdown || ''));

  // Remove hook afer use to keep it clean
  if (linkToNewTab) {
    DOMPurify.removeHook('afterSanitizeAttributes');
  }

  return {
    dangerouslySetInnerHTML: {
      __html: html,
    },
  };
}
